(function () {
  'use strict';
  if (window.tbmVisibleImagesReady) return;
  window.tbmVisibleImagesReady = true;
  function reveal(template) {
    if (!template.isConnected) return;
    const content = template.content.cloneNode(true);
    const image = content.querySelector('img');
    if (image) image.loading = 'eager';
    template.replaceWith(content);
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      const template = entry.target.querySelector('template[data-tbm-visible-image]');
      if (template) reveal(template);
      observer.unobserve(entry.target);
    });
  }, {rootMargin: '300px 0px'}) : null;
  function init(root) {
    root.querySelectorAll('template[data-tbm-visible-image]').forEach(function(template) {
      if (template.dataset.tbmObserved) return;
      template.dataset.tbmObserved = 'true';
      if (observer) observer.observe(template.parentElement);
      else reveal(template);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(document); }, {once: true});
  } else init(document);
  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
}());